import Component from './component'
import {connect} from 'react-redux'

export default connect(
    (state)=>({
       conteudo : function(){
           let s = state.database.paginas.findIndex(x=> parseInt(x.get('id')) == 1531425508165 )
           let as = state.database.paginas.get(s);
           if(as) return as.get('conteudo')
           else return ''
       }()
    }))(Component)



// WEBPACK FOOTER //
// ./src/views/website/home/container.js